var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 20.2485H22.5",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 20.2485V3.74853C13.4995 3.54962 13.4205 3.35886 13.2798 3.21821C13.1392 3.07755 12.9484 2.99854 12.7495 2.99854H3.74951C3.5506 2.99854 3.35983 3.07755 3.21918 3.21821C3.07853 3.35886 2.99951 3.54962 2.99951 3.74853V20.2485M20.9995 20.2485V9.74854C20.9995 9.54962 20.9205 9.35886 20.7798 9.21821C20.6392 9.07755 20.4484 8.99854 20.2495 8.99854H13.4995",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99951 6.74854H8.99951",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49951 12.7485H10.4995",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99951 16.4985H8.99951",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 16.4985H17.9995",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4995 12.7485H17.9995",
    stroke: "#47AD1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIcon);
export default __webpack_public_path__ + "static/media/organizationIcon.68bfe57036bea2341a353ae3e6dbfa83.svg";
export { ForwardRef as ReactComponent };